import Api from '@/services/Api'

// Razmjena izlaznih racuna medju Roboot serverima (SQL A9).
// Ovaj server je PRIMATELJ: zove klijentov server i upisuje racune kojih nema.
export default {
  // samoPregled: true -> nista se ne upisuje, samo se javi koliko ih ima
  povuci (tijelo) {
    return Api().post('razmjena/povuci', tijelo)
  }
}
